import React from 'react'
import Button from './Button'
import classNames from '../../utils/classNames'
import { getTextColorBasedOnBackground } from '../Sites/Prerequisites'

interface ComponentProps {
  disabled?: boolean
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  className: string
  buttonClassNames?: string
  secondaryColor: string
  buttonText: string
  minWidth?: number | string
  buttonType?: 'button' | 'submit' | 'reset'
  style?: React.CSSProperties
  isInternalComponentHidden?: boolean
  componentWidth?: string | number
  dataTestId?: string
}

const BookerButton = ({
  disabled,
  onClick,
  className,
  secondaryColor,
  buttonText,
  minWidth,
  buttonType,
  style,
  isInternalComponentHidden,
  componentWidth,
  buttonClassNames,
  dataTestId
}: ComponentProps) => (
  <div className={className} style={{ width: componentWidth || 150 }}>
    {!disabled && !isInternalComponentHidden && (
      <div
        style={{
          backgroundColor: secondaryColor,
          minWidth: minWidth || '100%',
          height: 45,
        }}
        className='opacity-50 absolute rounded-md right-0 z-0'></div>
    )}
    <Button
      style={{
        backgroundColor: secondaryColor,
        height: 45,
        transition: 'transform .3s',
        color: getTextColorBasedOnBackground(secondaryColor),
        ...style,
      }}
      className={classNames(
        ' transition-transform transform hover:-translate-y-1.5 text-white float-right z-10 relative w-full font-bold',
        buttonClassNames
      )}
      size='large'
      dataTestId={dataTestId}
      disabled={disabled}
      onClick={onClick}
      type={buttonType}
      >
      <div className='-mt-0.5'>{buttonText}</div>
    </Button>
  </div>
)

export default BookerButton
